import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-all-in-one-pcs-for-computer-labs-and-offices',
    templateUrl: './all-in-one-pcs-for-computer-labs-and-offices.component.html',
    styleUrls: ['./all-in-one-pcs-for-computer-labs-and-offices.component.scss']
})
export class AllInOnePcsForComputerLabsAndOfficesComponent implements OnInit {

    constructor(
        private titleService: Title,
        private metaService: Meta,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('Why All-in-One PCs Are Ideal for Computer Labs and Offices | Virsa');
        this.metaService.updateTag({ name: 'description', content: 'Discover why All-in-One PCs are the best choice for computer labs, schools, and offices. Learn the benefits and features of Virsa All-in-One PCs for modern workspaces.' });
        this.metaService.updateTag({ name: 'keywords', content: 'Best All-in-One PCs for computer labs, All-in-One PCs for offices, AIO computers for education, Space-saving computers for offices, All-in-One desktop advantages, Best computers for computer labs, All-in-One PC for schools, AIO computers benefits, Modern office computer solutions, Virsa All-in-One PCs' });
    }

}
